export default __webpack_public_path__ + "static/media/illustration-study-2-n-w@2x.4bdc8171.png";